import { Audit } from '../../main/Investments/redux/types';

/* Action Tyes */
const loginTypes = {
    LOGIN_REQ: 'LOGIN_REQ',
    LOGIN_REQ_SUCCESS: 'LOGIN_REQ_SUCCESS',
    LOGIN_REQ_FAILED: 'LOGIN_REQ_FAILED',
    SET_USER_DATA: 'SET_USER_DATA',
    REMOVE_USER_DATA: 'REMOVE_USER_DATA',
    SIGN_UP_REQ: 'SIGN_UP_REQ',
    UPDATE_BANKDETAILS: 'UPDATE_BANKDETAILS',
    UPDATE_USER_PROFILE: 'UPDATE_USER_PROFILE',
    UPDATE_KYC_INFO: 'UPDATE_KYC_INFO',
    UPDATE_INVESTOR_PROFILE: 'UPDATE_INVESTOR_PROFILE',
    UPDATE_MYINFO_PATH: 'UPDATE_MYINFO_PATH',
    FETCH_INVETSOR_BY_UUID: 'FETCH_INVETSOR_BY_UUID',
};
export default loginTypes;

export interface CommonAction {
    type: string;
    payload: any;
}

export interface LoginForm {
    username: string;
    password: string;
}

export interface LoginState {
    loading: boolean;
    error?: string;
}

export interface UserProfile {
    firstName: string;
    lastName: string;
    phoneNumber: {
        countryCode: string;
        number: number;
    };
    linkedInProfile?: string;
}

export interface User {
    email: string;
    userType?: string;
    uuid: string;
    status: string;
    referralCode: string;
    userProfile?: UserProfile;
    creationAudit?: {
        updatedAt: string;
    };
}

export interface BankAccount {
    accountCurrency: string;
    accountName: string;
    accountNumber: string;
    bankAccountUUID: string;
    beneficiaryBank: {
        bankCode: string;
        bankName: string;
        branchCode?: string;
        swiftCode: string;
    };
}

export type KYCDocType =
    | 'Identity Proof'
    | 'Address Proof'
    | 'Wealth Proof'
    | 'Certificate of Incorporation'
    | 'Constitution'
    | 'Register of Directors'
    | 'Register of Shareholders'
    | 'Financial Statement'
    | 'Authorised Signatory List';
export interface KYCDoc {
    uuid: string;
    title: string;
    type: KYCDocType;
    url: string;
    isDeleted?: boolean;
}

export interface KYCInfo {
    address?: {
        address1: string;
        country: string;
        postalCode: string;
        address2?: string;
    };
    identity?: {
        identityNumber: string;
        identityType: string;
    };
    legalFirstName?: string;
    legalLastName?: string;
    companyRegNumber?: string;
    legalEntityName?: string;
    type?: 'Myinfo';
    legalName?: string;
    nationality?: string;
    residentialStatus?: string;
    aliasName?: string;
    hanyuPinyinName?: string;
    hanyuPinyinAliasName?: string;
    marriedName?: string;
    dob?: string;
    gender?: string;
    birthCountry?: string;
    noa?: {
        amount: {
            amountUpto2dp: number;
            currency: string;
        };
        yearofAssessment: string;
    };
}

export interface Aggrements {
    agreementType: 'AIConsent' | 'NDA' | 'SubscriptionAgreement' | 'HIPL AI Consent';
    entityType: string;
    entityUUID: string;
    file?: string;
    status: string;
    uuid: string;
    venue: string;
    lastAudit: {
        at: string;
        event: string;
        by?: string;
    };
    shouldResign?: boolean;
}

export type InvestorType = 'Institutional' | 'Individual Accredited' | 'Corporate Accredited';

export interface AIReview {
    status: string;
    comment: string;
    audit: Audit;
}
export interface Investorstatus {
    profile?: string;
    kyc?: string;
    accreditation?: string;
}
export interface Investor {
    investorType: InvestorType;
    status: Investorstatus;
    uuid: string;
    skipNDA?: boolean;
    accreditation?: {
        status: string;
        activeQualificationStatus?: string;
        documents?: {
            url: string;
            uuid: string;
            title?: string;
            type?: string;
            isDeleted: boolean;
        }[];
        timestamp: string;
        reviews?: AIReview[];
    };
    isHIPL: boolean;
    profile?: {
        companyName?: string;
        institutionType?: string;
        companyWebsite?: string;
        employmentStatus?: string;
        jobTitle?: string;
        investmentExperience?: string;
        countryOfIncorporation?: string;
        authorityRegulatedBy?: string;
    };
    team?: {
        teamName: string;
    };
    preferences?: {
        investmentTypes?: string[];
        investmentHorizon?: string[];
        riskPreference?: string[];
        geographies?: string[];
        sectors?: string[];
        ticketSize?: string[];
    };
    bankAccounts?: BankAccount[];
    kyc?: {
        docs: KYCDoc[];
        info: KYCInfo;
        reviewsV2?: ReviewsV2[];
    };
    agreements?: Aggrements[];
}

export interface ReviewsV2 {
    entity: 'HSPL' | 'HIPL';
    reviewAudits?: {
        action: string;
        comment: string;
    }[];
    status: string;
}

export interface UserState {
    uuid?: string;
    jwtToken?: string;
    user?: User;
    investor?: Investor;
    currentStep?: number;
    myinfoPath?: 'setting' | 'onboarding';
}

/*  actions protocals */
export interface loginReqAction {
    type: typeof loginTypes.LOGIN_REQ;
    payload: {
        user_data: UserState;
        url_key?: string;
    };
}

export interface loginReqSuccessAction {
    type: typeof loginTypes.LOGIN_REQ_SUCCESS;
}

export interface loginReqFailedAction {
    type: typeof loginTypes.LOGIN_REQ_FAILED;
}

export interface setUserDataAction {
    type: typeof loginTypes.SET_USER_DATA;
    payload: UserState;
}

export interface removeUserDataAction {
    type: typeof loginTypes.REMOVE_USER_DATA;
}

export type LoginActionTypes = loginReqAction | loginReqSuccessAction | loginReqFailedAction;
